declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_widget_float_table_column_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_column_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_column_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['collapse'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_column_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_column_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_column_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_col_name__value_shm_hitalama_map_widget_float_table_column_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['name'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_col_name['value'] >
	>
	type $shm_hitalama_map_widget_float_table_col_name__commit_shm_hitalama_map_widget_float_table_column_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['name_commit'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_col_name['commit'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_column_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_column_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['Name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_column_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_table_column_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_table_column_13 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_table_column_14 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_column_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_column_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['Width'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table_column_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table_column_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['type_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_table_column_19 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_column_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_column_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['Type'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_table_column_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_column_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['expand'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table_column_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_table_column_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_table_column_26 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_table_column_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table_column_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__label_shm_hitalama_map_widget_float_table_column_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['label'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table_column_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_column['Code_scroll'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_column_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_table_column_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_table_column_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	export class $shm_hitalama_map_widget_float_table_column extends $mol_view {
		title( ): string
		Title( ): $mol_view
		collapse( next?: any ): any
		Collapse( ): $mol_button_minor
		collapse_visible( ): readonly(any)[]
		close( next?: any ): any
		Close( ): $mol_button_minor
		Head( ): $mol_view
		name( next?: string ): string
		name_commit( next?: any ): any
		Name( ): $shm_hitalama_map_widget_float_table_col_name
		Name_label( ): $mol_labeler
		width( next?: number ): number
		Width( ): $mol_number
		Width_label( ): $mol_labeler
		type( next?: string ): string
		type_options( ): Record<string, any>
		Type( ): $mol_select
		Type_label( ): $mol_labeler
		expand( next?: any ): any
		Expand_icon( ): $mol_icon_code_braces
		Expand( ): $mol_button_minor
		code( next?: string ): string
		Code( ): $mol_textarea
		Code_scroll( ): $mol_scroll
		Code_label( ): $mol_labeler
		help( ): string
		Help( ): $mol_view
		code_visible( ): readonly(any)[]
		Content( ): $mol_list
		Body( ): $mol_scroll
		panel_content( ): readonly(any)[]
		table( ): $shm_hitalama_map_widget_float_table
		column( ): number
		expanded( next?: boolean ): boolean
		attr( ): ({ 
			'shm_hitalama_map_widget_float_table_column_expanded': ReturnType< $shm_hitalama_map_widget_float_table_column['expanded'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $shm_hitalama_map_widget_float_table_column['panel_content'] >
	}
	
}

//# sourceMappingURL=column.view.tree.d.ts.map